import {get} from "lodash";

export function getPointsBalanceFromUser(user) {
  return get(
    user,
    "loyaltyProfile.data.rewardPointBalance.balance",
    0,
  );
}
